<div class="catches-container">

  <!-- Filter Panel -->
  <div class="filter-panel">
    <app-catch-filter-panel 
      [showAnglerNotes]="true" 
      (filterChange)="onFilterChange($event)">
    </app-catch-filter-panel>
  </div>

  <!-- Action Bar -->
  <div class="action-bar">
    <span class="catch-count">
      {{ isLoading ? '…' : displayedFeatures.length }} catch{{ displayedFeatures.length === 1 ? '' : 'es' }} found
    </span>
    <button mat-stroked-button
            [disabled]="filteredCatchIds.length === 0 || isLoading"
            (click)="goToFirstCatch()">
      Go to First Catch →
    </button>
  </div>

  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>

  <!-- Table -->
  <app-catch-table *ngIf="!isLoading" [features]="displayedFeatures" [listParam]="catchListParam"></app-catch-table>

</div>
